webpackJsonp([96961042003272],{

/***/ 198:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.pageQuery = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _glamorous = __webpack_require__(5);
	
	var _glamorous2 = _interopRequireDefault(_glamorous);
	
	var _reactHelmet = __webpack_require__(59);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _components = __webpack_require__(12);
	
	var _style = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Header = _glamorous2.default.div.withConfig({
	  displayName: 'page__Header'
	})(_extends({}, _style.border.bottom({ color: _style.colors.gray200 }), _style.margin.bottom(5), _style.padding.x(3), {
	  display: 'flex',
	  minHeight: 340,
	  alignItems: 'center',
	  justifyContent: 'center',
	  backgroundColor: _style.colors.gray100,
	  position: 'relative',
	  zIndex: 0,
	  overflow: 'hidden'
	}));
	
	var Title = _glamorous2.default.h1.withConfig({
	  displayName: 'page__Title'
	})(_extends({}, _style.typography.largeTitle, {
	  color: _style.colors.white
	}));
	
	var PageTemplate = function PageTemplate(_ref) {
	  var data = _ref.data,
	      location = _ref.location;
	
	  var page = data.contentfulPage;
	  var siteUrl = data.site.siteMetadata.siteUrl;
	
	  return _react2.default.createElement(
	    'article',
	    { style: _extends({}, _style.padding.bottom(5)) },
	    _react2.default.createElement(
	      _reactHelmet2.default,
	      null,
	      _react2.default.createElement(
	        'title',
	        null,
	        page.title
	      ),
	      _react2.default.createElement('link', {
	        rel: 'canonical',
	        href: '' + siteUrl + location.pathname.replace(/\/$/, '')
	      })
	    ),
	    _react2.default.createElement(
	      Header,
	      null,
	      _react2.default.createElement(_components.BackgroundImage, {
	        sizes: page.featuredImage.sizes,
	        alt: page.featuredImage.title
	      }),
	      _react2.default.createElement(
	        Title,
	        null,
	        page.title
	      )
	    ),
	    _react2.default.createElement(_components.Markdown, {
	      alignCenter: location.pathname === '/contact',
	      dangerouslySetInnerHTML: {
	        __html: page.body.childMarkdownRemark.html
	      }
	    })
	  );
	};
	
	exports.default = PageTemplate;
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-page-js-a880a0f3762e1b88175f.js